import React, { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getWinnerMessage } from 'slices/winnerMessageSlice';
import LoaderCP from '../../components/loader';
import FormInternational from '../../components/finalWinner/FormInternational';
import NoForm from '../../components/finalWinner/NoForm';
import InvalidAccount from '../../components/finalWinner/InvalidAccount';
import FinalWinnerComp from '../../components/finalWinner';
import FormProduct from '../../components/finalWinner/FormProduct';
import FormNational from '../../components/finalWinner/FormNational';

const FinalWinnerContainer = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const rewardType = atob(searchParams.get('rewardType'));
  const auctionId = atob(searchParams.get('auctionId'));
  // Uncomment to allow a fake member session to be created
  // const { status } = 'success';
  const { status } = useSelector((state) => state.user);
  const { winnerMessageStatus, winnerMessageData } = useSelector((state) => (state.winnerMessage));

  useEffect(() => {
    dispatch(getWinnerMessage({ auctionId }));
  }, []);

  const selectWinnerMessage = ({ type }) => {
    switch (type) {
      case 'AlreadyRegistered':
        return <NoForm type={rewardType} />;
      case 'InvalidAccount':
        return <InvalidAccount />;
      default:
        return <></>;
    }
  };

  const renderFinalWinnerContainer = () => {
    if (status === 'error' || winnerMessageStatus === 'error') {
      return <FinalWinnerComp />;
    }

    if (winnerMessageStatus === 'success' && winnerMessageData.type !== 'NoError') {
      return selectWinnerMessage(winnerMessageData);
    }

    if (status === 'success') {
      switch (rewardType) {
        case 'PRODUCT':
          return <FormProduct />;
        case 'NATIONAL':
          return <FormNational />;
        case 'INTERNATIONAL':
          return <FormInternational />;
        default:
          return <></>;
      }
    }

    return <LoaderCP />;
  };

  return (
    <>
      {
        renderFinalWinnerContainer()
      }
    </>
  );
};

export default FinalWinnerContainer;
